import { render, staticRenderFns } from "./new-parks.vue?vue&type=template&id=69273684&scoped=true&"
import script from "./new-parks.vue?vue&type=script&lang=js&"
export * from "./new-parks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69273684",
  null
  
)

export default component.exports